'use client';

import Script from 'next/script';
import { Suspense, useEffect, useState } from 'react';
import { isNative } from '@/lib/native';
import { GoogleAnalyticsPageView } from './google-analytics-pageview';

/** Analytics remains available on the web but is never loaded by the iOS shell. */
export function AnalyticsScripts({
  gaMeasurementId,
  gtmId,
}: {
  gaMeasurementId?: string;
  gtmId?: string;
}) {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => setEnabled(!isNative()), []);
  if (!enabled) return null;

  const directGa = Boolean(gaMeasurementId) && !gtmId;
  return (
    <>
      {directGa && gaMeasurementId && (
        <>
          <Script
            src={`https://www.googletagmanager.com/gtag/js?id=${gaMeasurementId}`}
            strategy="afterInteractive"
          />
          <Script id="ga4" strategy="afterInteractive">
            {`window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
window.gtag = gtag;
gtag('js', new Date());
gtag('config', '${gaMeasurementId}', { send_page_view: false });`}
          </Script>
          <Suspense fallback={null}>
            <GoogleAnalyticsPageView measurementId={gaMeasurementId} />
          </Suspense>
        </>
      )}
      {gtmId && (
        <>
          <Script id="gtm" strategy="afterInteractive">
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`}
          </Script>
          <noscript>
            <iframe
              src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
              height="0"
              width="0"
              style={{ display: 'none', visibility: 'hidden' }}
              title="Google Tag Manager"
            />
          </noscript>
        </>
      )}
    </>
  );
}
